// @ts-nocheck
import _ from 'lodash';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import * as generateOrderActions from './sagaActions';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as constants from './constants';
import OrderInfo from './orderInfo';
import ReserveInventory from './reserveInventory';
import ReviewOrders from './reviewOrders';
import SelectSKUs from './selectSKU';
import SelectStores from './selectStores';
import * as dynamicGridSagaActions from 'models/dynamicGrid/sagaActions';
import PageLayout from 'templates/pageLayout';
import { hasReserverInventory } from './selectors';
import { Steps } from 'antd';
import './orders.scss';
import { Link } from 'react-router-dom';
import { fetchTableColumns } from 'models/tableColumns/sagaActions';
import { useColumnAliasName } from 'hooks/useColumnAliasName';

type TProps = {};

const GenerateOrderModal = (props: TProps) => {
	const dispatch = useDispatch();
	const [currentStep, setCurrentStep] = React.useState(0);
	const hasReserveInventory = useSelector(hasReserverInventory);

	React.useEffect(() => {
		dispatch(generateOrderActions.loadModal());
		dispatch(fetchTableColumns(constants.UPLOAD_MODEL_ID));
		return () => {
			dispatch(generateOrderActions.cleanUp());
		};
	}, [dispatch]);

	const getColumnAliasName = useColumnAliasName(constants.UPLOAD_MODEL_ID);

	const hideModal = React.useCallback(() => {
		dispatch(
			dynamicGridSagaActions.cleanUpGrids({
				tableIds: [
					constants.MODAL_TABLE_IDS.STORES,
					constants.MODAL_TABLE_IDS.SKUS,
					constants.MODAL_TABLE_IDS.INVENTORY,
				],
			})
		);
		dispatch(generateOrderActions.cleanUp());
	}, [dispatch]);

	const steps = [
		{
			title: getColumnAliasName('Order Information'),
			component: <OrderInfo hideModal={hideModal} handleNextClick={() => setCurrentStep(1)} />,
		},
		{
			title: getColumnAliasName('Select Store'),
			component: (
				<SelectStores
					hideModal={hideModal}
					handleNextClick={() => setCurrentStep(2)}
					goBack={() => setCurrentStep(0)}
				/>
			),
		},
		{
			title: getColumnAliasName('Select SKUs'),
			component: (
				<SelectSKUs
					hideModal={hideModal}
					handleNextClick={() => setCurrentStep(3)}
					goBack={() => setCurrentStep(1)}
				/>
			),
		},
		...(hasReserveInventory
			? [
					{
						title: getColumnAliasName('Reserve Inventory'),
						component: (
							<ReserveInventory
								hideModal={hideModal}
								handleNextClick={() => setCurrentStep(4)}
								goBack={() => setCurrentStep(2)}
							/>
						),
					},
				]
			: []),
		{
			title: getColumnAliasName('Review Orders'),
			component: (
				<ReviewOrders hideModal={hideModal} goBack={() => setCurrentStep(hasReserveInventory ? 3 : 2)} />
			),
		},
	];
	// Removes `false` or `undefined` values

	return (
		<PageLayout>
			<Stack isVertical isStretch gutter="small">
				<StackItem>
					<div className="card-head order-steps-wrapper">
						<Link to="/orders?selectedTab=all" className="modal-close">
							<div className="card-head-title">
								<i className="icon-back" />
								Back to Order
							</div>
						</Link>
						<div className="order-steps">
							<Steps size="small" current={currentStep} labelPlacement="vertical">
								{steps.map((step, index) => (
									<Steps.Step key={index} title={step.title} />
								))}
							</Steps>
						</div>
					</div>
				</StackItem>
				<StackItem isStretch isGrow>
					<div className="card-body">{steps[currentStep].component}</div>
				</StackItem>
			</Stack>
		</PageLayout>
	);
};

export default GenerateOrderModal;
